import { ArrowDown } from 'assets/icons'
import TextButton from 'components/textButton'
import WORDING from 'constants/wording'
import { MeContext } from 'contexts/me'
import { MovementsContext } from 'contexts/movements'
import React, { useContext } from 'react'

const { VER_MAS_MOVIMIENTOS } = WORDING
const Pagination = () => {
  const { pagination, callActivitiesNextPage } = useContext(MovementsContext)
  const { me } = useContext(MeContext)
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {pagination?.current_page < (pagination?.total_pages ?? 0) - 1 && (
        <div className='flex justify-center w-full text-purple-900 md:mb-10'>
          <TextButton
            className='text-xs'
            handleFunction={() =>
              callActivitiesNextPage({
                walletUUID: me?.bank?.internal_account[0]?.wallet_account
              })
            }
            otherIcon
            icon={<ArrowDown className='mr-2 mt-[2px]' />}
          >
            {VER_MAS_MOVIMIENTOS}
          </TextButton>
        </div>
      )}
    </>
  )
}

export default Pagination
